import { render, staticRenderFns } from "./DeleteAuditDialog.vue?vue&type=template&id=2316a1df&scoped=true&"
import script from "./DeleteAuditDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteAuditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2316a1df",
  null
  
)

export default component.exports